// En: src/services/ArticleService.ts

import { IArticle } from "../types/Article";
import { apiClient } from "./apiClient";

const ENDPOINT = 'article'; // Usamos la ruta correcta del controlador

export const getArticles = async (): Promise<IArticle[]> => {
    try {
        return await apiClient(ENDPOINT, { method: 'GET' });
    } catch (error) {
        console.error("Error al obtener artículos:", error);
        throw error;
    }
};

export const getArticleById = async (id: number): Promise<IArticle | undefined> => {
    try {
        return await apiClient(`${ENDPOINT}/${id}`, { method: 'GET' });
    } catch (error) {
        console.error(`Error al obtener artículo por ID ${id}:`, error);
        return undefined;
    }
};

export const createArticle = async (articleData: Omit<IArticle, 'id'>): Promise<IArticle> => {
    try {
        return await apiClient(ENDPOINT, {
            method: 'POST',
            body: JSON.stringify(articleData),
        });
    } catch (error) {
        console.error("Error al crear artículo:", error);
        throw error;
    }
};

export const updateArticle = async (articleWithFullData: IArticle): Promise<IArticle | undefined> => {
    try {
        // Separamos el id de los datos a actualizar para evitar errores de validación
        const { id, ...updateData } = articleWithFullData as any;
        delete updateData.deletedAt; // También quitamos deletedAt por si acaso

        return await apiClient(`${ENDPOINT}/${id}`, {
            method: 'PATCH',
            body: JSON.stringify(updateData),
        });
    } catch (error) {
        console.error("Error al actualizar artículo:", error);
        throw error;
    }
};

export const deleteArticle = async (id: number): Promise<boolean> => {
    try {
        await apiClient(`${ENDPOINT}/${id}`, { method: 'DELETE' });
        return true;
    } catch (error) {
        console.error("Error al eliminar artículo:", error);
        return false;
    }
};

// --- Funciones de Toggle ---

export const toggleArticleVisibility = async (id: number, isHidden: boolean): Promise<IArticle | undefined> => {
    try {
        return await apiClient(`${ENDPOINT}/${id}`, {
            method: 'PATCH',
            body: JSON.stringify({ isHidden }),
        });
    } catch (error) {
        console.error("Error al cambiar visibilidad:", error);
        throw error;
    }
};

export const toggleArticleFeatured = async (id: number, isFeatured: boolean): Promise<IArticle | undefined> => {
    try {
        return await apiClient(`${ENDPOINT}/${id}`, {
            method: 'PATCH',
            body: JSON.stringify({ isFeatured }),
        });
    } catch (error) {
        console.error("Error al cambiar estado de destacado:", error);
        throw error;
    }
};